<template>
  <div>

    <div class="block w-full">
      <div>
        <div class="inputTitle">
          {{ $t('userManagment.popups.importUsers.description') }}
        </div>
        <!-- <div class="inline-flex mt-5">
          <div class="mr-2 mb-1">
            {{ t('userManagment.popups.importUsers.anabUserQuestion') }}
          </div>
          <input type="checkbox" v-model="popupData.anabUsers">
        </div> -->
        <div>
          <input type="file" @change="fileChanged" id="file">
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { useSystemStore } from "@/stores/system/SystemStore";
const systemStore = useSystemStore();

const fileChanged = (event) =>{
  systemStore.uploadedFile = event.target.files[0];
};
</script>
<style scoped>

</style>
